import AddIcon from '@material-ui/icons/Add';
import AppBar from '@material-ui/core/AppBar';
import Asan from './images/asan.png';

import { Box } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import Cervical from './Cervical';
import Conclusion from './Conclusion';
import Checkbox from '@material-ui/core/Checkbox';

import Extra from './Extra';

import FormControlLabel from '@material-ui/core/FormControlLabel';

import PropTypes from 'prop-types';

import React, {useEffect} from 'react';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Thyroid from './Thyroid';
import ThyroidClinicalTable from './ThyroidClinicalTable';

import { makeStyles } from '@material-ui/core/styles';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  tableRightBorder : { borderWidth: 1, borderColor: 'black',borderStyle: 'solid'},
  tableRightBorderHeader : { borderWidth: 1, borderColor: 'white',borderStyle: 'solid'} 
}));

export default function MainView() {
  const classes = useStyles();
  const [tabValue, setTabValue] = React.useState(0);

  const defaultValue = { 
    'location' : {'type': '', 'position' : ''}, 
    'vascularity' : {'none': false, 'peripheral': false, 'mild': false, 'marked': false}, 
    'diameter' : ['','','','','','cm'], 
    'changeInSize' : {'initial': false, 'followup': false, 'value':''}, 
    'composition' : '', 
    'spongiform' : '', 
    'cometTailArtifact' : '', 
    'orientation' : '' , 
    'margin' : '', 
    'echogenicity' : '', 
    'calcification' : { 'micro' : false, 'rim' : false, 'macro' : false, 'entire':''},
    'biopsy': {'onChecked': false, 'type': '', 'FnaDevice':'', 'CnbSize':''}, 
    'comment': '',
    'complications' : {'yes': false, 'no':false, "othersTxt": "", "intrathyroidal": false, "perithyroidal": false , "others" : false},
    'extrathyroidal' : '',
    'extrathyroidal2' : '', // Gross ETE로 선택시, Minor ETE도 중복 선택 가능하도록 요청 (2023/Jun/26)
    'extrathyroidalLocation' : {'ant': false, 'post':false, 'med': false, 'lateral': false},
    'extrathyroidalGross' : {'trachea': false, 'RLN': false, 'strap': false, 'others': false, 'input':''},
    'diffuseLesion':'',
    'note':'',     
    'recommendation':''
  }

  const defaultValueClinic = { 
    'normalThy' :true,
    'clinicalInformation' : 'Thyroid nodule',
    'clinicEtc':'' ,
    'historyDate' :['','',''],
    'history': {'fna': false, 'cnb': false, 'target':'', 'pathologic': ''},  
    'usDate' : ['','',''], 
    'size' : { 'sizeType' : '' , 'right' : false , 'isthmus' : false , 'left': false} , 
    'rightValue' : ['','','','cm'],
    'isthmusValue' : ['','','cm'],
    'leftValue' : ['','','','cm'],
    'parenchymalEchotexture' : '' , 
    'diffusionThyroidDisease' : false , 
    'multinodule':false,
    'parenchymalVascularity' : '' , 
    'addConclusion': false
  }

  const defaultValueCervical = {
    'location': {'neck':'', 'position':''},
    'neckLevel' : {'level1' : false, 'level2' : false,'level3' : false, 'level4' : false, 'level5' : false, 'level6' : false, 'level7' : false}, 
    'imageDiag' : '',
    'diameter' : ['', '', 'cm', 'cm'], 
    'note' : '' ,
    'biopsy': false, 
    'FNA' : {'checked':false, 'level1' : false, 'level2' : false,'level3' : false, 'level4' : false, 'level5' : false, 'level6' : false, 'level7' : false}, 
    'CNB' : {'checked':false, 'level1' : false, 'level2' : false,'level3' : false, 'level4' : false, 'level5' : false, 'level6' : false, 'level7' : false}, 
    'complications' : {'yes': false, 'valueInput':'', 'no':false}, 
  }
  
  window.localStorage.setItem("noduleDefault", JSON.stringify([
    {'key' : 'R' , 'data' : [{...defaultValue}]},
    {'key' : 'L' , 'data' : [{...defaultValue}]},
    {'key' : 'IS' , 'data' : [{...defaultValue}]}    
  ]));

  // Initialize
  window.localStorage.setItem("noduleClinicDefault", JSON.stringify(defaultValueClinic));
  // window.localStorage.setItem("noduleDefault", JSON.stringify(defaultValue));  
  window.localStorage.setItem("nodeDefault", JSON.stringify(defaultValueCervical));  

  if(window.localStorage.getItem("node") === null){
    window.localStorage.setItem("node", JSON.stringify([defaultValueCervical]));  
  }
  if(window.localStorage.getItem("nodeNormal") == null){
    window.localStorage.setItem("nodeNormal", 'true');  
  }


  const [nodules, setNodules] = React.useState(
    // JSON.parse(window.localStorage.getItem("nodule")) || 
    [
    {'key' : 'R' , 'data' : [{...defaultValue}]},
    {'key' : 'L' , 'data' : [{...defaultValue}]},
    {'key' : 'IS' , 'data' : [{...defaultValue}]}    
  ]);

  const [noduleClinic, setNoduleClinic] = React.useState(JSON.parse(window.localStorage.getItem("noduleClinic")) || defaultValueClinic);

  useEffect(() => {
    window.localStorage.setItem("nodule", JSON.stringify(nodules));   
    window.localStorage.setItem("noduleClinic", JSON.stringify(noduleClinic));
}, [nodules, noduleClinic]);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const saveNodule = (type, index, data) => {
    // console.log('----------------- , ', nodules);
    var _nodules = [...nodules];
    // console.log(_nodules, type, index);
    for(let nodule of _nodules ){
      if(nodule.key.charAt(0) === type.charAt(0)){
        // console.log('type : ', type);
        // console.log('index : ', index);    
        nodule.data[index] = data;        
      }
    }    
    window.localStorage.setItem("nodule", JSON.stringify(_nodules));

    // console.log('save : ' , JSON.parse(window.localStorage.getItem("nodule")));
    //setNodules(_nodules);
  }
  
  const deleteThyroid = (deleteThyroidFlag) => {
    if(deleteThyroidFlag){
      var _nodules = [];

      _nodules = [
          {'key' : 'R' , 'data' : [{...defaultValue}]},
          {'key' : 'L' , 'data' : [{...defaultValue}]},
          {'key' : 'IS' , 'data' : [{...defaultValue}]}    
        ];
        
      setNodules(_nodules);
      window.localStorage.setItem("nodule", JSON.stringify(_nodules));
      console.log(nodules);
    }
    window.location.reload();
  }

  const uncheckNormal = (normal) => {
    var _noduleClinic = {...noduleClinic};
    if(normal) _noduleClinic.normalThy = true;
    else _noduleClinic.normalThy = false;
    // console.log(noduleClinicProp.normalThy);
    // window.localStorage.setItem("noduleClinic", JSON.stringify(_noduleClinicProp));    
    // console.log('MainView : noduleClinicList.normalThy : ' , _noduleClinic.normalThy); 
    setNoduleClinic(_noduleClinic);
  }

  const addNodule = (type) =>{   
    var _nodules = [...nodules];

    for(let nodule of _nodules ){
      if(nodule.key.charAt(0) === type.charAt(0)){
        nodule.data.push({...defaultValue});
      }
    }    
    window.localStorage.setItem("nodule", JSON.stringify(_nodules));

    setNodules(_nodules);
  }

  // const removeNodule = (type) =>{   
  //   var _nodules = [...nodules];

  //   for(let nodule of _nodules ){
  //     if(nodule.key.charAt(0) === type.charAt(0)){
  //       nodule.data.pop();
  //     }
  //   }    
  //   window.localStorage.setItem("nodule", JSON.stringify(_nodules));

  //   setNodules(_nodules);
  // }

  // console.log('nodules : ' , nodules);

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
          <Tabs
            value={tabValue}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            style={{position:'fixed', width:'100%', backgroundColor:'#E8E8E8', zIndex:100}}
          >
            <Tab label="Thyroid" {...a11yProps(0)} />
            <Tab label="Cervical Lymph Node" {...a11yProps(1)} />
            <Tab label="Extrathyroidal Lesion " {...a11yProps(2)} />
            <Conclusion/>
          </Tabs>
      </AppBar>
        <TabPanel value={tabValue} index={0}>
          <h1><center><br/>Thyroid</center></h1>
          <ThyroidClinicalTable deleteThyroid={deleteThyroid} noduleClinic={noduleClinic} setNoduleClinic={setNoduleClinic} />
          <div align="center" style={{backgroundColor:'grey', color:'white' , width : 'calc(91.5% + 150px)', height : '30px', fontSize:'14px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>Thyroid Nodule</div>
          <div style={{display: 'flex'}}>        
            {
              nodules.map((nodule,index)=>
              <div style={{width : (index===0 ? 'calc(32% + 150px)' : '32%')}}>
                <div>
                  {nodule.data.map((data, _index) =>
                    <Thyroid noduleClinic={noduleClinic} setNoduleClinic={setNoduleClinic} noduleData={data} index={_index} saveNodule={saveNodule} uncheckNormal={uncheckNormal} menu={(index===0 ? true : false)} title={nodule.key + (_index+1)} addNodule={addNodule}/>        
                  )}
                </div>
                <div align="center">
                <Button color='primary' disabled={nodules[index].data.length > 2 /* Oct 17, 2023 2. 현재 nodule이 추가되는게 무한정으로 되고 있는데 각 위치별 (right, left, isthmus)로 3개씩으로 한정되도록 부탁드립니다. */} startIcon={<AddIcon />} onClick={(event)=>{
                    addNodule(nodule.key);}} style={{marginTop:'10px'}}>Add Nodule
                </Button>         
                {/* <Button color='secondary' disabled={nodule.data.length === 0 ? true : false} startIcon={<RemoveIcon />} onClick={(event)=>{
                    removeNodule(nodule.key);}} style={{marginTop:'10px'}}>Remove Nodule
                </Button>  */}
                </div>             
              </div>
              )
            }    
          </div>  
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <h1><center><br/>Cervical Lymph Node</center></h1>
          <Cervical/>
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <h1><center><br/>Extrathyroidal Lesion </center></h1>
          <Extra/>
        </TabPanel> 
        <br/><br/>
        <hr/>
        <FormControlLabel control={<Checkbox name="Add to conclusion" color="primary" size='small' 
          defaultChecked={noduleClinic.addConclusion ? noduleClinic.addConclusion : false} checked={noduleClinic.addConclusion ? noduleClinic.addConclusion : false} 
          onChange={(event) => {
            var _noduleClinic = {...noduleClinic};
            _noduleClinic.addConclusion = event.target.checked;
            setNoduleClinic(_noduleClinic);}}/>} label="아래 판독문에 추가하기"/>
        <p>* Malignancy risk stratification system: 2021 K-TIRADS (Korean Thyroid Imaging Reporting and Data System) (Korean J Radiol.2021;22:2094-2123) 
        <br/>K-TIRADS 1     No thyroid nodule 
        <br/>K-TIRADS 2     Benign (malignancy risk &lt; 3%): iso-/hyperechoic spongiform nodule, partially cystic with echogenic foci and comet tail artifacts, pure cyst [Biopsy: Not indicated]
        <br/>K-TIRADS 3     Low suspicion (malignancy risk 3-10%): isoechoic or partially cystic nodules without suspicious US features. [Biopsy: &gt; 20 mm]
        <br/>K-TIRADS 4     Intermediate suspicion (malignancy risk 10-40%): solid hypoechoic nodule without suspicious US feature / isoechoic or partially cystic nodules with suspicious US features. Entirely calcified nodule. [Biopsy: &gt; 10-15 mm]
        <br/>K-TIRADS 5     High suspicion (malignancy risk &gt; 60%): solid hypoechoic nodule with suspicious US features. [Biopsy: &gt; 10 mm]
        <br/>[Biopsy for nodules is indicated regardless of nodule size if there is suspicion of metastasis (distant, lymph node), obvious gross ETE of trachea or recurrent laryngeal nerve, and clinical suspicion of medullary thyroid cancer]
        </p>
        <hr/>
        <br/>
        <center>Version 4.3 <br/>
          Last updated on Apr 11, 2024 by TwinLab</center> 
        <center><br/> Special thanks to <br/>
        <img src={Asan} width='200' alt='asan'/> </center>      
      </div>
  );
}